import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { UserCheckIcon } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-12 md:py-20 bg-amber text-charcoal-dark" data-id="element-363" data-mp="2sjufvuorrn4a">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-364" data-mp="36a7kpo6d6lpe">
        <FadeIn data-id="element-365" data-mp="36bsg1g0i68ob">
          <div className="flex justify-center mb-6" data-id="element-366" data-mp="31jhg4d5rimvr">
            <UserCheckIcon className="w-12 h-12 text-charcoal-dark/80" data-id="element-367" data-mp="31ho9gxv5g2nr" />
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold mb-6" data-id="element-368" data-mp="3g6u2u57b2ynq">
            Solo 10 lugares
          </h2>
          <div className="space-y-4 text-lg font-medium text-charcoal-dark/90 max-w-2xl mx-auto" data-id="element-369" data-mp="3b8snnvd03jhj">
            <p data-id="element-370" data-mp="3p80muo95yrlq">
              Acompaño personalmente a cada persona durante las 12 semanas. Eso
              requiere mi atención directa, así que trabajo con 10 personas a la
              vez. No más.
            </p>
            <p className="text-2xl font-bold text-charcoal-dark mt-6" data-id="element-371" data-mp="1uwlwc58bwo4x">
              Si estás leyendo esto, hay lugar.
            </p>
            <p className="text-sm uppercase tracking-widest opacity-70 mt-2" data-id="element-372" data-mp="2suftg70a7cow">
              No garantizo que lo haya mañana.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}